<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-emissions/>
		<VMain>
			<breadcrumbs />
			<div>
				<form-input
					v-if="questions && questions.length > 0"
					:name="name"
					:questions="questions"
					:inputAnswers="answers"
					@submitForm="sendEmissionsReport"
				/>
			</div>
			<orixe-footer/>
		</VMain>
  </v-app>
</template>
<script>
import EmissionsApi from "../api/emissions/emissions"
import LoadingState from "../consts/LoadingState"
import FormInputEmissions from "../components/FormInputEmissions.vue"

export default {
	name: "EmissionsInput",
	components: {
		"form-input": FormInputEmissions,
	},
	data() {
		return {
			questions: null,
			name: "EmissionsReport",
			id: "2021",
			answers: [],
			gotoemissions: false,
		}
	},
	props: {
		preview: Boolean,
		previewID: Number,
	},
	mounted() {
		this.gotoemissions=this.$route.query.maketrue
		this.loadEmissionsForm()
	},
	methods: {
		loadEmissionsForm() {
			EmissionsApi.getEmissionsForm()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{
							root: true,
						}
					)
					let first = data[0] 
					if (first.emissionID && !this.gotoemissions) {
						return this.$router.push("/emissions/"+first.emissionID)
					}else if (this.gotoemissions){
						first = data[1]
					}

					this.name = first.name
					this.id = first.id
					this.$set(this,"questions", first.questions)
					// this.fileID = data.fileID

				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		sendEmissionsReport(answers) {
			EmissionsApi.submitForm(this.id, answers)
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully completed Emissions Form with ID '${data}'`,
						{ root: true }
					)

					this.$router.push(`/emissions/${data}`)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	}
}
</script>
